import Login from '../components/Login'
import LoginByToken from '../components/LoginByToken'

let routes = {
  path: '/login',
  component: resolve => require(['../components/layout/Login'], resolve),
  children: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/login-by-token/:id?',
      name: 'LoginByToken',
      component: LoginByToken
    },
  ]
}

export default routes



// WEBPACK FOOTER //
// ./src/router/login.js